import React, {Component,} from "react"
import {styled} from '@mui/material/styles';
import {Link as RouterLink} from 'react-router-dom'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, {tableCellClasses} from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TablePagination from '@mui/material/TablePagination';
import {Avatar, Link, Button, Typography, Box, Accordion, AccordionSummary, AccordionDetails} from "@mui/material";
import { HiDownload } from 'react-icons/hi';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import get_and_post_data_skeleton from '../../common/common/get_and_post_data_skeleton';
import { Select, MenuItem } from '@mui/material';
import { FaChevronDown } from 'react-icons/fa';

const paths = require('../../../paths.json');


const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
       backgroundColor: 'var(--rebranding-content-background-color)',
       color: 'white',
       fontSize: '16px',
       fontWeight: '600',
       paddingTop: '20px',
       paddingBottom: '20px',
       borderBottom: 'none',
       textAlign: 'center',
       justifyContent: 'center',
    },
    [`&.${tableCellClasses.body}`]: {
       backgroundColor: 'var(--rebranding-content-background-color)',
       fontSize: '14px',
       color: '#9CA3B4',
       borderBottom: 'none',
       shading: 'none',
       fontWeight: '600',
       textAlign: 'center',
    },
 }));

const StyledTableRow = styled(TableRow)(({theme}) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 'none',

    },
}));

const truncateWithEllipsis = (str, maxLength) => {
    return str.length > maxLength ? str.slice(0, maxLength) + '...' : str;
  };

// TBC Pagination for tables
// This needs to be converted to setState logic
// const [page, setPage] = React.useState(2);
// const [rowsPerPage, setRowsPerPage] = React.useState(10);
// const handleChangePage = (event, newPage) => {
//     setPage(newPage);
// };
//
// const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
// };


class BillingHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // billing
            user_transactions: [],
            page_user_transactions: [],
            filtered_transactions: [],
            page_num: 0,
            n_rows_per_page: 5,
            stripe_url: '',
            filterBy: 'all',
            selectedOption: 'all'
        };
        this.handleChangePage = this.handleChangePage.bind(this);
        this.OpenStripeUserProfile = this.OpenStripeUserProfile.bind(this);
        this.StripeRedirect = this.StripeRedirect.bind(this);
        this.filterTransactions = this.filterTransactions.bind(this);
    }

    componentDidMount() {
        this.get_settings_billing_page_django_data(
            paths.BACKEND_URL + "api/settings_page_billing_page_info",
            'get',
        )
        this.OpenStripeUserProfile()
    }

    filterTransactions(transactions, filterType) {
        if (filterType === 'all') {
            return transactions;
        } else if (filterType === 'memberships') {
            return transactions.filter(transaction => 
                transaction.description.toLowerCase().includes('subscription')
            );
        } else if (filterType === 'one_time_purchases') {
            return transactions.filter(transaction => 
                transaction.description.toLowerCase().includes('single content')
            );
        } else if (filterType === 'collection_purchases') {
            return transactions.filter(transaction => 
                transaction.description.toLowerCase().includes('collection')
            );
        }
        return transactions;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedOption !== this.state.selectedOption) {
            const filtered = this.filterTransactions(this.state.user_transactions, this.state.selectedOption);
            this.setState({
                page_user_transactions: filtered,
                page_num: 0
            });
        }
    }

    OpenStripeUserProfile() {
        this.get_settings_billing_page_django_data(
            paths.BACKEND_URL + "checkout/stripe_user_page/",
            'post',
            false,
            {},
            this.StripeRedirect,
        )
    }
    StripeRedirect(res){
        this.setState({stripe_url: res.data.url})
    }
    handleChangePage(event, newPage) {
        this.setState({page_num: newPage})
     };
    get_settings_billing_page_django_data = get_and_post_data_skeleton

    render() {
        // function make_user_transition_list(user_transactions) {
        //     user_transactions.map(
        //         (tran, index) => {
        //             let tran_status;
        //             if (tran['type'] === 'p') {
        //                 if (tran['status'] === 'paid') {
        //                     tran_status = (
        //                         <td className="settings_billing_history_table_col_text_green">
        //                             Paid
        //                         </td>
        //                     )
        //                 } else if (tran['status'] === 'open') {
        //                     tran_status = (
        //                         <td className="settings_billing_history_table_col_text_orange">
        //                             Pending
        //                         </td>
        //                     )
        //                 } else {
        //                     tran_status = (
        //                         <td className="settings_billing_history_table_col_text_red">
        //                             Failed
        //                         </td>
        //                     )
        //                 }
        //             } else if (tran['type'] === 'r') {
        //                 if (tran['status'] === 'Refunded') {
        //                     tran_status = (
        //                         <td className="settings_billing_history_table_col_text_green">
        //                             {tran['status']}
        //                         </td>
        //                     )
        //                 } else if (tran['status'] === 'Failed') {
        //                     tran_status = (
        //                         <td className="settings_billing_history_table_col_text_red">
        //                             {tran['status']}
        //                         </td>
        //                     )
        //                 } else if (tran['status'] === 'Pending') {
        //                     tran_status = (
        //                         <td className="settings_billing_history_table_col_text_orange">
        //                             {tran['status']}
        //                         </td>
        //                     )
        //                 }
        //             }
        //             return (
        //                 <tr>
        //                     <td className="settings_billing_history_table_col_text">
        //                         {tran['date']}
        //                     </td>
        //                     <td className="settings_billing_history_table_col_text">
        //                         {tran['price']}
        //                     </td>
        //                     <td className="settings_billing_history_table_col_text"> {tran['influencer']}</td>
        //                     <td className="settings_billing_history_table_col_text">
        //                         {tran['description']}
        //                     </td>
        //                     {tran_status}
        //                     <td className="settings_billing_history_table_col_text"><a href={tran['invoice_url']}
        //                                                                                className="settings_get_invoice_button"
        //                                                                                id="settings_get_invoice_button">INVOICE</a>
        //                     </td>
        //                 </tr>
        //             )
        //         }
        //     )
        // }

        // var user_transistions_list = (
        //     make_user_transition_list(this.state.user_transactions)
        // )
        // let settings_page_div = (
        //     <div className="settings_billing_history_settings_div" id="settings_billing_history_settings_div">
        //         <a href="checkout/stripe_user_page/" id="settings_billing_history_edit_payment_method_button" className="settings_billing_history_edit_payment_method_button">EDIT PAYMENT DETAILS AND BILLING ADDRESS</a>
        //         <table className="settings_billing_history_table_upper">
        //             <thead>
        //                 <tr className="settings_billing_history_hr">
        //                     <th className="settings_billing_history_table_col_title_upper" style={{width: '10%'}}>Date</th>
        //                     <th className="settings_billing_history_table_col_title_upper" style={{width: '10%'}}>Amount</th>
        //                     <th className="settings_billing_history_table_col_title_upper" style={{width: '20%'}}>Influencer</th>
        //                     <th className="settings_billing_history_table_col_title_upper" style={{width: '40%'}}>Description</th>
        //                     <th className="settings_billing_history_table_col_title_upper" style={{width: '10%'}}>Status</th>
        //                     <th className="settings_billing_history_table_col_title_upper" style={{width: '10%'}}>Invoice</th>
        //                 </tr>
        //             </thead>
        //         </table>
        //         <div className="settings_billing_history_outer_div" >
        //             <table className="settings_billing_history_table_lower">
        //                 <thead className="lower_table_head">
        //                     <tr className="settings_billing_history_hr">
        //                         <th className="settings_billing_history_table_col_title_upper" style={{width: '10%'}}></th>
        //                         <th className="settings_billing_history_table_col_title_upper" style={{width: '10%'}}></th>
        //                         <th className="settings_billing_history_table_col_title_upper" style={{width: '20%'}}></th>
        //                         <th className="settings_billing_history_table_col_title_upper" style={{width: '40%'}}></th>
        //                         <th className="settings_billing_history_table_col_title_upper" style={{width: '10%'}}></th>
        //                         <th className="settings_billing_history_table_col_title_upper" style={{width: '10%'}}></th>
        //                     </tr>
        //                 </thead>
        //                 {user_transistions_list}
        //             </table>
        //         </div>
        //     </div>
        // )
        return (
            <div>
            <Grid
               Container
               xs={12}
            //    justifyContent="center"
            >
            <Grid
                container    
            >
            <Grid
               container
               xs={12} md={6}
            >
                <Typography
                style={{
                    color: '#222222',
                    fontSize: '26px',
                    fontWeight: '600',
                    paddingBottom: '20px',
                }}
                >Transactions</Typography>
            </Grid>
            <Grid 
                container
                item
                xs={12}
                sm={12} 
                md={6} 
                lg={6}
                justifyContent="right"
                alignItems="right"
            >   
                <Box
                    sx={{display: {xs: 'none', md: 'flex'}}}
                >
                    <Select
                    sx={{
                        maxHeight: '42px', 
                        minHeight: '42px', 
                        backgroundColor: 'white', 
                        zIndex: '999',
                        margin: '0px 20px 0px 0px',
                        width: '200px', 
                        borderRadius: '8px',
                        fontSize: '14px',
                        fontFamily: 'Roboto',
                        fontWeight: '500',
                    }}
                    IconComponent={(props) => (
                        <FaChevronDown style={{ fontSize: '14px', marginRight: '10px', color: '#757575' }} {...props} />
                    )}
                    value={this.state.selectedOption}
                    onChange={(e) => {
                        this.setState({ selectedOption: e.target.value });
                    }}
                    MenuProps={{ style: { zIndex: '999' } }}
                >
                    <MenuItem value={'all'}>All Transactions</MenuItem>
                    <MenuItem value={'memberships'}>Memberships</MenuItem>
                    <MenuItem value={'one_time_purchases'}>Purchased Content</MenuItem>
                    <MenuItem value={'collection_purchases'}>Purchased Collections</MenuItem>
                </Select>
                <Button
                    disableRipple
                    variant="contained"
                    sx={{
                       backgroundColor: 'var(--brand-color)',
                        fontSize: '14px',
                        maxHeight: '42px', 
                        minHeight: '42px', 
                        textTransform: 'none',
                        marginBottom: '20px',
                        boxShadow: 'none',
                        borderRadius: '8px',
                        fontFamily: 'Roboto',
                        fontWeight: '500',
                        ':hover': {
                           backgroundColor: 'var(--brand-color-hover)',
                            color: 'white', boxShadow: 'none',
                        },
                    }}
                    type="submit" value="LOGIN"
                    onClick={() => {
                        setTimeout(() => {
                            window.open(this.state.stripe_url)
                        }, 800);
                        }}>
                    Edit Payment Details
                </Button>
                </Box>

            </Grid>
            <Grid 
                container
                item
                xs={12}
                sm={12} 
                justifyContent="left"
                alignItems="left"
            >   
                <Box
                    sx={{display: {xs: 'flex', md: 'none'}, width: '100%'}}
                >
                    
                <Button
                    disableRipple
                    variant="contained"
                    sx={{
                       backgroundColor: 'var(--brand-color)',
                        fontSize: '14px',
                        textTransform: 'none',
                        maxHeight: '42px', 
                        minHeight: '42px', 
                        marginBottom: '20px',
                        boxShadow: 'none',
                        fontWeight: '600',
                        borderRadius: '8px',
                        fontFamily: 'Roboto',
                        fontWeight: '500',
                        ':hover': {
                           backgroundColor: 'var(--brand-color-hover)',
                            color: 'white', boxShadow: 'none',
                        },
                    }}
                    type="submit" value="LOGIN"
                    onClick={() => {
                    
                        setTimeout(() => {
                            window.open(this.state.stripe_url)
                        }, 800);
                        }}>
                    Edit Payment Details
                </Button>
                </Box>

                <Box sx={{display: {xs: 'flex', md: 'none'}, width: window.innerWidth > 400 ? '200px' : '100%', marginBottom: '20px'}}>
                <Select
                    sx={{
                        maxHeight: '42px', 
                        minHeight: '42px', 
                        backgroundColor: 'white', 
                        zIndex: '999',
                        width: '100%', 
                        fontSize: '14px',
                        borderRadius: '8px',
                        fontFamily: 'Roboto',
                        fontWeight: '500',
                    }}
                    IconComponent={(props) => (
                        <FaChevronDown style={{ fontSize: '14px', marginRight: '10px', color: '#757575' }} {...props} />
                    )}
                    value={this.state.selectedOption}
                    onChange={(e) => {
                        this.setState({ selectedOption: e.target.value });
                    }}
                    MenuProps={{ style: { zIndex: '999' } }}
                >
                    <MenuItem value={'all'}>All Transactions</MenuItem>
                    <MenuItem value={'memberships'}>Memberships</MenuItem>
                    <MenuItem value={'one_time_purchases'}>Purchased Content</MenuItem>
                    <MenuItem value={'collection_purchases'}>Purchased Collections</MenuItem>
                </Select>
                </Box>
            </Grid>




            </Grid>
                {/* Desktop */}
                <Box
                    sx={{
                        display: {xs: 'none', 'md': 'flex'},
                    }}
                >
                <Grid
                    container
                    spacing={0}
                    alignItems="center"
                    justifyContent="center">
                    <Grid xs={12} sm={12} md={12} lg={12}>
                        {/*Billings Table*/}
                        <TableContainer component={Paper} sx={{boxShadow: 'none', backgroundColor: 'var(--rebranding-content-background-color)'}}>
                            <Table sx={{minWidth: 650, backgroundColor: 'var(--rebranding-content-background-color)'}} size="small" aria-label="a dense table">
                                <TableHead>
                                    <StyledTableRow sx={{borderBottom: '2px black solid', color: '#222222'}}>
                                        <StyledTableCell style={{color: '#222222'}}>Date</StyledTableCell>
                                        <StyledTableCell style={{color: '#222222'}} align="right">Amount</StyledTableCell>
                                        <StyledTableCell style={{color: '#222222'}} align="right">Influencer</StyledTableCell>
                                        <StyledTableCell style={{color: '#222222'}} align="right">Description</StyledTableCell>
                                        <StyledTableCell style={{color: '#222222'}} align="right">Status</StyledTableCell>
                                        <StyledTableCell style={{color: '#222222'}} align="right">Invoice</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.page_user_transactions.slice(this.state.page_num*this.state.n_rows_per_page, (this.state.page_num+1)*this.state.n_rows_per_page).map((user_transaction,index) => {
                                        let user_transaction_status;
                                        let user_transaction_style = {};
                                        if ((user_transaction['type'] === 'p') || (user_transaction['type'] === 'p_ios')) {
                                            if (user_transaction['status'] === 'paid') {
                                                // this needs to be green text
                                                user_transaction_status = 'Paid'
                                                user_transaction_style = {color: 'green'}
                                            } else if (user_transaction['status'] === 'succeeded') {
                                                // this needs to be orange text
                                                user_transaction_status = 'Paid'
                                                user_transaction_style = {color: 'green'}
                                            } else if (user_transaction['status'] === 'open') {
                                                // this needs to be orange text
                                                user_transaction_status = 'Pending'
                                                user_transaction_style = {color: 'orange'}
                                            } else {
                                                // this needs to be red text
                                                user_transaction_status = 'Failed'
                                                user_transaction_style = {color: 'red'}
                                            }
                                        } else if (user_transaction['type'] === 'r') {
                                            if (user_transaction['status'] === 'Refunded') {
                                                // this needs to be green
                                                user_transaction_status = user_transaction['status']
                                                user_transaction_style = {color: 'green'}
                                            } else if (user_transaction['status'] === 'Failed') {
                                                // this needs to be red
                                                user_transaction_status = user_transaction['status']
                                                user_transaction_style = {color: 'red'}
                                            } else if (user_transaction['status'] === 'Pending') {
                                                // this needs to be orange
                                                user_transaction_status = user_transaction['status']
                                                user_transaction_style = {color: 'orange'}
                                            }
                                        }
                                        return (
                                            <StyledTableRow
                                                key={'user_transaction_' + index}
                                                // sx={{ '&:last-child td, &:last-child th': { border: 1 } }}
                                            >
                                                <StyledTableCell style={{color: 'var(--light-theme-text-color)',}} component="th" scope="row">
                                                    {user_transaction['date']}
                                                </StyledTableCell>
                                                <StyledTableCell style={{color: 'var(--light-theme-text-color)', textTransform: user_transaction['price'].includes('kr') ? 'none' : 'uppercase'}} align="right">{user_transaction['price']}</StyledTableCell>
                                                <div
                                                    style={{cursor:'pointer'}}
                                                    onClick={() => window.location.assign(window.location.origin+'/'+user_transaction['influencer'])}>
                                                <StyledTableCell style={{color: 'var(--light-theme-text-color)',}} component="th" scope="row"
                                                                sx={{ justifyContent: 'center', display: 'flex', height: '100%' , verticalAlign: 'middle' }}>
                                                    <Avatar
                                                    sx={{ width: '30px', height: '30px', marginTop: '10px' }}
                                                    alt={user_transaction['influencer_name']}
                                                    src={user_transaction['icon_image_path']}>
                                                    </Avatar>
                                                    <p style={{ marginLeft: '10px' }}>{truncateWithEllipsis(user_transaction['influencer_name'], 20)}</p>

                                                </StyledTableCell>
                                            </div>
                                                <StyledTableCell style={{color: 'var(--light-theme-text-color)',}} align="right">{user_transaction['description']}</StyledTableCell>
                                                <StyledTableCell style={user_transaction_style} align="right">{user_transaction_status}</StyledTableCell>
                                                <StyledTableCell style={{color: 'var(--light-theme-text-color)',}} align="right">
                                                    {user_transaction['type'] !== 'p_ios' ? <a style={{color: 'var(--light-theme-text-color)',}} className={'invoice_text_link'} sx={{ position: 'absolute' }} href={user_transaction['invoice_url']} target="_blank" >
                                                        <HiDownload color='var(--light-theme-text-color)' style={{ width: '20px', height: 'auto', color: 'var(--light-theme-text-color)' }}/>
                                                    </a> : '-'}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            count={this.state.user_transactions.length}
                            page={this.state.page_num}
                            onPageChange={this.handleChangePage}
                            rowsPerPageOptions={this.state.n_rows_per_page}
                            rowsPerPage={this.state.n_rows_per_page}
                        />
                    </Grid>
                </Grid>    
                </Box>    
                {/* Mobile */}
                <Box
                    sx={{
                        display: {xs: 'flex', 'md': 'none'},
                    }}
                >
                <Grid
                    container
                    spacing={0}
                    alignItems="center"
                    justifyContent="center">
                    <Grid xs={12} sm={12} md={12} lg={12}>
                        {/*Billings Table*/}
{/* 
                        <TableContainer component={Paper} sx={{boxShadow: 'none', backgroundColor: 'var(--rebranding-content-background-color)'}}>
                            <Table sx={{minWidth: 650, backgroundColor: 'var(--rebranding-content-background-color)'}} size="small" aria-label="a dense table">
                                <TableHead>
                                    <StyledTableRow sx={{borderBottom: '2px black solid'}}>
                                        <StyledTableCell>Date</StyledTableCell>
                                        <StyledTableCell align="right">Amount</StyledTableCell>
                                        <StyledTableCell align="right">Influencer</StyledTableCell>
                                        <StyledTableCell align="right">Description</StyledTableCell>
                                        <StyledTableCell align="right">Status</StyledTableCell>
                                        <StyledTableCell align="right">Invoice</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody> */}
                                    {this.state.page_user_transactions.slice(this.state.page_num*this.state.n_rows_per_page, (this.state.page_num+1)*this.state.n_rows_per_page).map((user_transaction,index) => {
                                        let user_transaction_status;
                                        let user_transaction_style = {};
                                        if (user_transaction['type'] === 'p') {
                                            if (user_transaction['status'] === 'paid') {
                                                // this needs to be green text
                                                user_transaction_status = 'Paid'
                                                user_transaction_style = {color: 'green'}
                                            } else if (user_transaction['status'] === 'succeeded') {
                                                // this needs to be orange text
                                                user_transaction_status = 'Paid'
                                                user_transaction_style = {color: 'green'}
                                            } else if (user_transaction['status'] === 'open') {
                                                // this needs to be orange text
                                                user_transaction_status = 'Pending'
                                                user_transaction_style = {color: 'orange'}
                                            } else {
                                                // this needs to be red text
                                                user_transaction_status = 'Failed'
                                                user_transaction_style = {color: 'red'}
                                            }
                                        } else if (user_transaction['type'] === 'r') {
                                            if (user_transaction['status'] === 'Refunded') {
                                                // this needs to be green
                                                user_transaction_status = user_transaction['status']
                                                user_transaction_style = {color: 'green'}
                                            } else if (user_transaction['status'] === 'Failed') {
                                                // this needs to be red
                                                user_transaction_status = user_transaction['status']
                                                user_transaction_style = {color: 'red'}
                                            } else if (user_transaction['status'] === 'Pending') {
                                                // this needs to be orange
                                                user_transaction_status = user_transaction['status']
                                                user_transaction_style = {color: 'orange'}
                                            }
                                        }
                                        return (
                                            <Grid
                                            container
                                            item
                                            xs={12}
                                         >
                                         <Accordion
                                            style={{
                                               backgroundColor: 'var(--rebranding-content-background-color)',
                                               color: '#9CA3B4',
                                               width: '100%',
                                            }}
                                         >
                                            <AccordionSummary
                                               expandIcon={<ExpandMoreIcon style={{color: '#9CA3B4', fontSize: '30px', paddingRight: '20px'}}/>}
                                               aria-controls="panel1a-content"
                                               id="panel1a-header"
                                               style={{padding: '0px', margin: '0px', width: '100%'}}
                                            >
                                                <Typography
                                                    style={{
                                                        fontSize: '16px',
                                                        fontWeight: '600',
                                                        paddingTop: '10px',
                                                        paddingLeft: '20px',
                                                        color: 'var(--light-theme-text-color)',
                                                    }}
                                                >
                                                    {user_transaction['date']}
                                                </Typography>
                                               <Avatar
                                                  sx={{ width: '40px', height: '40px', marginTop: '0px', marginBottom: '0px', marginLeft: '20px' }}
                                                      alt={user_transaction['influencer_name']}
                                                      src={user_transaction['icon_image_path']}>
                                               </Avatar>
                                               <Typography style={{ marginTop: '5px', paddingTop: '5px', marginBottom: '0px', fontSize: '16px', fontWeight: '600', marginLeft: '10px', color: 'var(--light-theme-text-color)', }}>{truncateWithEllipsis(user_transaction['influencer_name'], 20)}</Typography>
                                               {/* <Typography
                                                  style={{
                                                     float: 'right',
                                                     right: '80px',
                                                     position: 'absolute',
                                                    fontSize: '16px',
                                                    fontWeight: '600',
                                                    paddingTop: '10px',
                                                    color: 'var(--light-theme-text-color)',
                                                  }}
                                               >
                                                    
                                               </Typography> */}
                                            </AccordionSummary>
                                            <AccordionDetails>
                                               <Grid
                                                  container
                                                  xs={12}
                                               >
                                                  <Grid
                                                     container
                                                     item
                                                     xs={8}
                                                  >
                                                     <Typography
                                                        style={{
                                                           fontSize: '16px',
                                                           fontWeight: '600',
                                                        //    paddingTop: '10px',
                                                        color: 'var(--light-theme-text-color)',
                                                        }}
                                                     >
                                                        {user_transaction['description']} - <span style={{ textTransform: user_transaction['price'].includes('kr') ? 'none' : 'uppercase' }}>{user_transaction['price']}</span>
                                                     </Typography>
                                                  </Grid>
                                                  <Grid
                                                     container
                                                     item
                                                     justifyContent="right"
                                                     style={{padding: '0px', margin: '0px', paddingRight: '50px'}}
                                                     xs={4}
                                                  >
                                                    <Typography
                                                        style={user_transaction_style}
                                                        sx={{
                                                            paddingTop: '0px',
                                                            marginTop: '0px',
                                                            fontSize: '16px',
                                                            fontWeight: '600',
                                                            position: 'absolute',
                                                            bottom: '17.5px',                    
                                                            color: 'var(--light-theme-text-color)',
                                                        }}
                                                    >
                                                        {user_transaction_status}
                                                        <a className={'invoice_text_link'} sx={{ position: 'absolute', paddingLeft: '10px', color: 'var(--light-theme-text-color)',}} href={user_transaction['invoice_url']} target="_blank" >
                                                            <HiDownload color={'#9CA3B4'} style={{height: '100%', width: '20px', fontSize: '26px', paddingLeft: '10px', color: 'var(--light-theme-text-color)',}}/>
                                                        </a>
                                                    </Typography>
                                                  </Grid>
                                               </Grid>
                                            </AccordionDetails>
                                         </Accordion>
                                         </Grid>
                                            // <StyledTableRow
                                            //     key={'user_transaction_' + index}
                                            //     // sx={{ '&:last-child td, &:last-child th': { border: 1 } }}
                                            // >
                                            //     <StyledTableCell component="th" scope="row">
                                            //         {user_transaction['date']}
                                            //     </StyledTableCell>
                                            //     <StyledTableCell align="right">{user_transaction['price']}</StyledTableCell>
                                            //     <StyledTableCell align="right">{user_transaction['influencer']}</StyledTableCell>
                                            //     <StyledTableCell align="right">{user_transaction['description']}</StyledTableCell>
                                            //     <StyledTableCell style={user_transaction_style} align="right">{user_transaction_status}</StyledTableCell>
                                            //     <StyledTableCell align="right">
                                            //         <a className={'invoice_text_link'} sx={{ position: 'absolute' }} href={user_transaction['invoice_url']} target="_blank" >
                                            //             <HiDownload color={'#9CA3B4'} style={{ width: '20px', height: 'auto' }}/>
                                            //         </a>
                                            //     </StyledTableCell>
                                            // </StyledTableRow>
                                        )
                                    })}
                                {/* </TableBody>
                            </Table>
                        </TableContainer> */}
                        <TablePagination
                            component="div"
                            count={this.state.user_transactions.length}
                            page={this.state.page_num}
                            onPageChange={this.handleChangePage}
                            rowsPerPageOptions={this.state.n_rows_per_page}
                            rowsPerPage={this.state.n_rows_per_page}
                        />
                    </Grid>
                </Grid>    
                </Box>  
                </Grid>
  
            </div>
        )
    }
}

export default BillingHistory;